import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectNotFoundUrl } from '../../selectors/notFoundUrl';
import { EmptyPage } from '../../components/EmptyPage';
import { trackNavigationToFlats, trackNavigationToJK } from './tracking';
import { selectComparePageType } from '../../selectors/page';

export const EmptyPageContainer: React.FC<{}> = () => {
  const notFoundUrl = useSelector(selectNotFoundUrl);
  const pageType = useSelector(selectComparePageType);

  const handleClick = React.useCallback(() => {
    if (pageType === 'newbuildings') {
      trackNavigationToJK();
    } else {
      trackNavigationToFlats();
    }
  }, [pageType]);

  return <EmptyPage notFoundUrl={notFoundUrl} onNotFoundUrlClick={handleClick} pageType={pageType} />;
};
